import { Col, Row, Tabs } from "antd";
import List from "common/display/List";
import { DeleteAction, EditAction } from "common/Form/ActionButton";
import FilledButton from "common/Form/Button";
import Layout from "common/Layout";
import React, { useEffect, useState } from "react";
import { TiPlus } from "react-icons/ti";
import { useNavigate, useLocation } from "react-router-dom";
import { authorizedRequest } from "api";

const Icon = () => <TiPlus style={{ marginRight: 4 }} />;

export default function Rules() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [groups, setGroups] = useState([]);
  const [currentGroup, setCurrentGroup] = useState(0);
  const [rules, setRules] = useState([]);

  const deleteRule = (id) =>
    authorizedRequest(`rules/${id}`, {
      method: "DELETE",
    })
      .then((success) =>
        authorizedRequest(`rules/${currentGroup}`, {
          method: "GET",
        })
      )
      .then((success) => {
        setRules(success.rules);
      })
      .catch((error) => console.error(error));

  useEffect(() => {
    authorizedRequest(`groups`, {
      method: "GET",
    })
      .then((success) => {
        const resposeGroups = success.groups.sort(
          (a, b) => a.group_id > b.group_id
        );
        setGroups(resposeGroups);
        setCurrentGroup(
          !!state ? state.groupId : "" + resposeGroups[0].group_id
        );
      })
      .catch((error) => console.error(error));
  }, [state]);

  useEffect(() => {
    authorizedRequest(`rules/${currentGroup}`, {
      method: "GET",
    })
      .then((success) => {
        setRules(success.rules);
      })
      .catch((error) => console.error(error));
  }, [currentGroup]);

  const groupItems = groups.map((group) => ({
    key: "" + group.group_id,
    label: group.name,
    children: (
      <List
        data={rules.map((rule) => ({
          name: rule.name,
          to: `/manager/rules/edit`,
          shine: !!state && parseInt(state.ruleId) === rule.rule_id,
          state: {
            ruleId: rule.rule_id,
            groupId: currentGroup,
          },
          actions: (
            <Row gutter={16} style={{ zIndex: 10 }}>
              <Col>
                <DeleteAction
                  onClick={(cb) => deleteRule(rule.rule_id).finally(cb)}
                />
              </Col>
              <Col>
                <EditAction
                  onClick={() =>
                    navigate(`/manager/rules/edit`, {
                      ruleId: rule.rule_id,
                      groupId: currentGroup,
                    })
                  }
                />
              </Col>
            </Row>
          ),
        }))}
      />
    ),
  }));

  return (
    <Layout
      headerLeftButton={{ content: "Mis proyectos", onClick: () => {} }}
      headerRightButton={{ content: "¿Cómo funciona?", onClick: () => {} }}
    >
      <Row>
        <Col xs={24}>
          <Row justify="end" gutter={48} style={{ alignSelf: "bottom" }}>
            <Col lg="auto">
              <FilledButton to={"/manager/tenders/new"}>
                <Icon /> Nuevo llamado
              </FilledButton>
            </Col>
            <Col lg="auto">
              <FilledButton green to={"/manager/rules/new"}>
                <Icon /> Nueva regla
              </FilledButton>
            </Col>
          </Row>
        </Col>
      </Row>

      <h1>Listado de reglas</h1>
      <Tabs
        defaultActiveKey="1"
        activeKey={"" + currentGroup}
        onChange={(k) => setCurrentGroup(k)}
        items={groupItems}
      />
    </Layout>
  );
}
